import React, { Component } from "react";
// import "./main.css";
import "./../App2.css";

import PAmenu from "./PAmenu";
// import PATopMenu from "./menu/PAtopMenu";
import PASideBar from "./PASideBar";
import PAsetup from "./PAsetup";
import PAonboarding from "./PAonboarding";
import styled, {
  css,
  ThemeProvider,
  isStyledComponent,
} from "styled-components";

import PATopBar from "./PATopBar";
import { BrowserRouter as Router } from "react-router-dom";
import { Switch, Route, Link } from "react-router-dom";

// import PAsb0 from "./PAsb0";
import { Sb0 as PAsb0 } from "./sb/Sb0";

import PApage from "./PApage";
// import {} from "./PApages";
import PAtabs from "./PAtabs";

import PAContentBlock from "./PAContentBlock";

import PAInputPrices from "./PAInputPrices";

import { vi, vpromos, subs } from "./../data";
import { vc } from "./../data/vc";
import { sites } from "./../data/sites";
import { game_keys } from "./../data/game_keys";

import { PaSelectMultiple, ButtonOutlineWhite } from "./uikit2";
import {
  Button,
  Card,
  Input,
  Breadcrumbs,
  Select,
  Dropdown,
  FormGroup,
  RadioGroup,
  ContentBlock,
  Icon,
  StatusDot,
  ButtonActions,
  Checkbox,
} from "xsolla-uikit";
import { IntlProvider } from "react-intl";

// DASHBOARD
import PAwelcome from "./PAwelcome";
import PAapps from "./dashboard/PAapps";
import PAdashboard, {
  PAdashUsers,
  PAdashPayouts,
  PAdashConnectors,
} from "./PAdashboard";
import PAsubsCharts from "./subscriptions/PAsubsCharts";
import PAsolutionsNew from "./cards/PAsolutionsNew";
import PAsolutionsMenu from "./menu/PAsolutionsMenu";

// SUPPORT
import PAusersSubscribers, {
  PAsupportProjectSelect,
} from "./support/PAusersSubscribers";
import PAusersSubscribers_old from "./support/PAusersSubscribers_old";
import { PAusersSubsPop } from "./support/PAusersSubsPop";
import PAusersSubscribersPage, {
  PAusersSubscribersPop,
} from "./support/PAusersSubscribersPage";
import PAusersStore from "./support/PAusersStore";
import PAusersButton from "./support/PAusersButton";
import PAcustomers from "./support/PAcustomers";

// ACCOUNTING
import PAaccountingTransactions from "./accounting/PAaccountingTransactions";
import PAaccountingDocuments from "./accounting/PAaccountingDocuments";
import PAaccountingPayouts from "./accounting/PAaccountingPayouts";
import PAaccountingReports from "./accounting/PAaccountingReports";

// ANTIFRAUD
import PAantifraud from "./antifraud/PAantifraud";
import PAantifraudComponents from "./antifraud/PAantifraudComponents";
import PAantifraudUsers from "./antifraud/PAantifraudUsers";

// SITE BUILDER
import PAsbStart from "./PAsbStart";
import PAsbProject from "./PAsbProject";
import PAsbSites from "./PAsbSites";
import PAsbSettings from "./sitebuilder/PAsbSettings";
import PAsbVersions from "./sitebuilder/PAsbVersions";
import PAsbStartPopup from "./PAsbStartPopup";

// LAUNCHER
import PAlauncherStart from "./PAlauncherStart";
import PAlauncher from "./PAlauncher";
import PAlauncherNew from "./PAlauncherNew";
import PAlauncherProject from "./PAlauncherProject";

// LOGIN
import PAlogin from "./PAlogin";
import PAloginProject from "./PAloginProject";
import PAloginSocials from "./PAloginSocials";
import PAloginStats from "./login/PAloginStats";
import PAloginWidget from "./login/PAloginWidget";
import PAloginSettings from "./login/PAloginSettings";

// GAME KEYS
import PAgameKeys from "./gk/PAgameKeys";
// import PAgameKeysList from "./PAGameKeysList";
import { WidgetWizard } from "./gk/PAgcWidgetWizard";
import { GameKeyWizard_temp } from "./gk/PAgcGameKeyWizard";
import PAgameKeysWizard from "./gk/PAgameKeysWizard";

// STORE
import PAstoreM from "./PAstoreM";
import PAvirtualItems from "./ingame/PAvirtualItems";
import PAvi from "./ingame/PAvi";
import PAviGroup from "./ingame/PAviGroup";
import PAviNewGroup from "./ingame/PAviNewGroup";
import PAviNewVirualItem from "./ingame/PAviNewVirualItem";
import PAvirtualCurrency from "./vc/PAvirtualCurrency";
import { PApromos } from "./ingame/PApromos";

import PAstore from "./PAstore";
import PAblue from "./PAblue";
// import PAingame from "./PAingame";
// import PAingame0 from "./PAingame0";
// import PAviItem from "./PAviItem";
// import PAsbStartPopup from "./PAsbStartPopup";

// VCS
import PAvcs from "./vc/PAvcs";
import PAvcNew from "./vc/PAvcNew";

// SUBSCR
import PAsubs from "./subscriptions/PAsubs";
import PAuserNotifications from "./subscriptions/PAuserNotifications";

//PARTNER NETWORK
import PApn from "./PApn";

// PAY STATION
import PApsSetting from "./pay_station/PApsSetting";
import PApsPaymentMethods from "./pay_station/PApsPaymentMethods";
import PApsPayrank from "./pay_station/PApsPayrank";
import PApsGateways from "./pay_station/PApsGateways";

import PS0 from "./ps/PS0";

// OTHER
import PAallConnectors from "./PAallConnectors";
import TempSkuName from "./uikit2/TempSkuName";

import {
  blankKey,
  blankKeyFilled,
  blankKeyFilled2,
  defaultWidget,
} from "./BlankKey";
import { PAchartMap, PAcharts } from './PAcharts';
import PAgkDashboard from "./PAgkDashboard";

import PAgkRefund, { PArefundVersion } from "./ffr/PAgkRefund";
import PAgkRefund_old from "./ffr/PAgkRefund_old";
import PAgkRefundSimple from "./ffr/PAgkRefundSimple";
import PAmodal from "./PApop";
import PAh2 from "./PAh2";
import { PArefundPreview } from "./ffr/PArefundPreview";
import { dashFull, dashMisha } from "./../data/pages";
import PAcards from "./com/PAcards";
import PAxcom from "./com/PAxcom";
import PAgkRefundEdit from "./ffr/PAgkRefundEdit";
import { PAsubsNew } from "./subscriptions/PAsubsNew";
import { VersionButton } from "./VersionButton";
import { CSSthemer } from "../data/themes";
import PAsbProjectP from "./PAsbProjectP";
import { PAapiReference } from "./developers/PAapiReference";
import { Chat } from "./chat/Chat";
import {
  PAsettingsContacts,
  PAsettingsContactsFull,
  PAsettingsContactsEmpty,
} from "./settings/PAsettingsContacts";
import { PAsettingsApi } from "./settings/PAsettingsApi";
import { PAsettingsUsers } from "./settings/PAsettingsUsers";
import { PAsettingsCompany } from "./settings/PAsettingsCompany";

export const GlobalContext = React.createContext();
export const ContextConsumer = GlobalContext.Consumer;

const Default = () => {
  return <Link to="/">home</Link>;
};

export class PA extends Component {
  constructor(props) {
    super(props);

    this.state = {
      version: "misha",  //'poydo'misha'misha2
      // currentState: 321,
      currentState: {
        activeKey: 123,
      },
      globalWebhooks: {
        value: false,
        needed: false,
      },
      globalAgreement: {
        value: false,
      },
      game_keys: {
        gameKeys: {
          enabled: false,
          keys: {
            my_project: {
              ...blankKeyFilled,
              widget: { ...defaultWidget },
            },
            my_project3: {
              ...blankKeyFilled2,
              widget: { ...defaultWidget },
            },

            my_project_another: {
              ...blankKey,
              widget: { ...defaultWidget },
            },
            my_project_third: {
              ...blankKey,
              widget: { ...defaultWidget },
            },
            my_project_fourth: {
              ...blankKey,
              widget: { ...defaultWidget },
            },
            // my_project1: { ...blankKey },
            // my_project2: {...blankKey}
          },
        },
      },
    };

    this.handleCurrentState = (what, value, callback) => {
      if (!what || !value) return;
      this.setState(
        {
          [what]: value,
        },
        callback && callback()
      );
    };

    this.readGlobal = (what = "Agreement") => {
      what = "global" + what;
      return this.state[what]["value"] ? true : false;
    };

    this.componentDidMount = () => {
      if (this.state.version === "misha2") {
        import("../../src/int.css");
      } else {
        import("../../src/int0.css");
      }
    };
  }

  render() {
    return (
      // <ThemeProvider theme={paThemes[this.state.version]}>
      <IntlProvider locale="en">
        <CSSthemer theme={this.state.version}>
          <VersionButton
            version={this.state.version}
            stateUpdater={(ver = "poydo") => {
              this.setState({ version: ver });
            }}
          />

          {/* <CssContentBlock
          width={this.state.version === 'poydo' ? false : '100%'}>
          <ContentBlock appearance='flatten'> */}
          <div
            style={{
              position: "absolute",
              overflowY: "scroll",
              top: 0,
              bottom: 28,
              left: 0,
              right: 0,
            }}
          >
            <Router>
              <div
                style={{
                  display:
                    this.state.version === "poydo"
                      ? "flex"
                      : this.state.version === "misha2"
                      ? "flex"
                      : "grid",
                }}
              >
                <GlobalContext.Provider
                  value={{
                    globalState: this.state,
                    handleCurrentState: this.handleCurrentState.bind(this),
                    readGlobal: this.readGlobal.bind(this),
                  }}
                  // value={{
                  //   state: {...this.state},
                  //   handleCurrentState: this.handleCurrentState.bind(this),
                  // }}
                >
                  {/* <div
              // className="pabody"
              style={{
                placeSelf: "start center",
                width: "100%",
                display: "flex",
                // display: this.state.version === "poydo" ? "flex" : "flex",
                flexDirection:
                  this.state.version === "poydo" ? "row" :
                  this.state.version === "misha2" ? "row" :
                  "column",
                maxWidth: this.state.version === "poydo" ? "100%" :
                this.state.version === "misha2" ? "100%" :
                1080
              }}
            > */}
                  {/* {this.state.version === "poydo" && <PASideBar />}
              {this.state.version === "misha2" && <PAonboarding />}
              {this.state.version === "misha" && <PATopBar />} */}

                  <div
                    // className={
                    //   this.state.version !== "misha" ? `app-root__content` : null
                    // }
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    <Chat />

                    <Switch>
                      <Route exact path="/"
                        render={(hist) => {
                          hist.history.push("/dashboard/all");
                          return null;
                        }}/>

                      <Route exact path="/chat">
                        <div />
                      </Route>

                      <Route path="/new"
                        render={(hist) => {
                          this.setState({ version: "misha" });

                          let newUrl = hist.history.location.pathname.split(
                            "/new"
                          )[1];

                          if (newUrl) {
                            hist.history.push(newUrl);
                          } else {
                            hist.history.push(`/dashboard`);
                          }

                          return null;
                        }}/>

                      <Route exact path="/start"
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root=""
                              title=""
                              appearance="flatten"
                              size="full"
                              defaultPage={{
                                appearance: "flatten",
                                size: "full",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component: <div />,
                                pop: {
                                  size: "xlg",
                                  appearance: "flatten",
                                  label: "welcome",
                                  title: "",
                                  component: (
                                    <PAblue
                                      backUrl={"/"}
                                      product="all"
                                      hist={hist}
                                    />
                                  ),
                                  // backUrl: '/',
                                },
                              }}
                            />
                          </div>
                        )}/>

                      <Route exact path="/cards"
                        render={(hist) => (
                          <div>
                            <PAcards backUrl={"/"} product="all" hist={hist} />
                          </div>
                        )}/>

                      <Route exact path="/ka"
                        render={(hist) => (
                          <div>
                            {" "}
                            //TODO: temp
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root=""
                              title=""
                              appearance="flatten"
                              size="full"
                              defaultPage={{
                                appearance: "flatten",
                                size: "full",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component: <div />,
                                pop: {
                                  size: "xlg",
                                  appearance: "flatten",
                                  label: "welcome",
                                  title: "",
                                  component: (
                                    <PAblue
                                      backUrl={"/"}
                                      ka={true}
                                      product="all"
                                      hist={hist}
                                    />
                                  ),
                                  // backUrl: '/',
                                },
                              }}
                            />
                          </div>
                        )}/>

                      <Route exact path="/manyprojects"
                        render={(hist) => (
                          <div>
                            {" "}
                            //TODO: temp
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root=""
                              title=""
                              appearance="flatten"
                              size="full"
                              defaultPage={{
                                appearance: "flatten",
                                size: "full",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component: <div />,
                                pop: {
                                  size: "xlg",
                                  appearance: "flatten",
                                  label: "welcome",
                                  title: "",
                                  component: (
                                    <PAblue
                                      backUrl={"/"}
                                      manyProjects={true}
                                      product="all"
                                      hist={hist}
                                    />
                                  ),
                                  // backUrl: '/',
                                },
                              }}
                            />
                          </div>
                        )}/>

                      <Route exact path={"/install"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="site_builder"
                              title=""
                              appearance="flatten"
                              defaultPage={{
                                appearance: "flatten",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component: <PAblue product="all" />,
                              }}
                            />
                          </div>
                        )}/>

                      <Route exact path="/developers"
                        render={(hist) => {
                          hist.history.push(`/developers/store`);
                          return null;
                        }}/>

                      <Route path="/developers/:keyId?"
                        render={(history) => {
                          return (
                            <PApage
                              version={this.state.version}
                              hist={history}
                              root="developers"
                              title="API reference"
                              tabs={{
                                store: {
                                  size: "wide",
                                  label: "Store",
                                  title: "Store API reference",
                                  extra: <Checkbox
                                  input={{
                                    onChange: e => void(0)
                                  }}
                                  label="Show token"
                                />,
                                  component: <PAapiReference />,
                                  // status: <StatusDot status="testing"/>
                                  // icon: "profile",
                                },

                                login: {
                                  size: "wide",
                                  label: "Login",
                                  title: "Login API reference",
                                  component: <PAapiReference />,
                                  // status: <StatusDot status="testing"/>
                                  // icon: "profile",
                                },
                              }}
                            />
                          );
                        }}/>

                      {/* <Route exact path={"/start"}>
                    <FormGroup>
                      <PAblue product="all"  />
                    </FormGroup>
                </Route> */}
                      {/*
                <Route exact path={[
                    // "/support/:keyId",
                    "/support/subscribers/:pageId",
                    // "/support/subscribers/:pageId",
                    ]}>
                    {(hist) => <div>
                      <PApage version={this.state.version} hist={hist}
                        root = 'support'
                        title = 'Support'
                        defaultPage = {{
                            label:  'Subscribers',
                            title:  'Subscribers',
                            component: <PAusersSubscribers history={hist} />,
                          }}
                      />
                      </div>
                    }
                </Route> */}
                      <Route exact path={"/support/:keyId?/:pageId?"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              style={{ padding: 24 }}
                              root="support"
                              title="Support"
                              size="wide"
                              defaultPage={{
                                size: "wide",
                                popup: true,
                                component: (
                                  <div>
                                    <PAusersSubscribers
                                      size="wide"
                                      history={hist}
                                    />
                                    <PAusersSubscribersPop
                                      size="wide"
                                      history={hist}
                                    />
                                  </div>
                                ),
                              }}
                              tabs={{
                                // transactions: {
                                //   label:  'Transactions',
                                // title:  'Transactions',
                                //   component: <div><PAusersStore /></div>,
                                //   counter: '16.224',
                                // },
                                subscribers: {
                                  size: "wide",
                                  // appearance: '100',
                                  label: "Subscribers",
                                  title: "Subscribers",
                                  extra: (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <PAsupportProjectSelect />
                                    </div>
                                  ),
                                  subComponent: {
                                    // label:  'Subscribers',
                                    // title:  'Subscribers',
                                    pop: {
                                      backUrl: "/support/subscribers",
                                      size: "lg",
                                      component: (
                                        <PAusersSubscribersPage
                                          history={hist}
                                        />
                                      ),
                                    },
                                    // extra: <div style={{display: 'flex', justifyContent: 'flex-end'}}><PAsupportProjectSelect/></div>,
                                    // component: <PAusersSubscribersPage history={hist} />,
                                  },
                                  component: (
                                    <PAusersSubscribers history={hist} />
                                  ),
                                },
                                subscribers_old: {
                                  size: "wide",
                                  // appearance: '100',
                                  label: "Subscribers",
                                  title: "Subscribers",
                                  component: (
                                    <PAusersSubscribers_old history={hist} />
                                  ),
                                  subComponent: (
                                    <PAusersSubscribersPage history={hist} />
                                  ),
                                  extra: (
                                    <div style={{ display: "flex" }}>
                                      Export&nbsp;&nbsp;
                                      <Button
                                        appearance="secondary"
                                        size="sm"
                                        appearance="flatten"
                                      >
                                        <Icon name="download" />
                                        XLS
                                      </Button>
                                      &nbsp;&nbsp;
                                      <Button
                                        appearance="secondary"
                                        size="sm"
                                        appearance="flatten"
                                      >
                                        <Icon name="download" />
                                        CSV
                                      </Button>
                                    </div>
                                  ),
                                  customTrigger: true,
                                  counter: "732",
                                },

                                subscribers_page_old: {
                                  size: "wide",
                                  // appearance: '100',
                                  label: "Subscribers",
                                  title: "Subscribers",
                                  component: <PAusersSubsPop history={hist} />,
                                  customTrigger: true,
                                  counter: "732",
                                },

                                customers: {
                                  size: "wide",
                                  // appearance: '100',
                                  label: "Microtransactions customers",
                                  title: "Microtransactions customers",
                                  component: (
                                    <div>
                                      <PAusersStore />
                                    </div>
                                  ),
                                  counter: "16.224",
                                },
                                users: {
                                  size: "wide",
                                  // appearance: '100',
                                  label: "Login Users",
                                  title: "Login Users",
                                  // icon: "profile",
                                  extra: (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <PAsupportProjectSelect />
                                    </div>
                                  ),
                                  component: <PAusersButton />,
                                  counter: "3.224",
                                },

                                // pop: {
                                //   label:  'New Group',
                                // title:  'New Group',
                                //   component: <PAusersSubscribersPop history={hist} />,
                                //   backUrl: '/support/subscribers',
                                // },

                                // users1: {
                                //   customTrigger: true,
                                //   label:  'User registry',
                                // title:  'User registry',
                                //                             //   subPage: {
                                //     root:'support/users',
                                //     label:  'Support',
                                // title:  'Support',
                                //     tabs: {
                                //       store: {
                                //         label:  'Store users',
                                // title:  'Store users',
                                //         component: <div>
                                //           <PAusersStore />
                                //         </div>,
                                //         counter: '16.224',
                                //       },
                                //       login: {
                                //         label:  'Login',
                                // title:  'Login',
                                //         component: <PAusersSubscribers history={hist} />,
                                //         extra: <div style={{display: 'flex',}}>
                                //           Export&nbsp;&nbsp;
                                //           <Button appearance="secondary" size="sm" appearance="flatten"><Icon name="download"/>XLS</Button>&nbsp;&nbsp;
                                //           <Button appearance="secondary" size="sm" appearance="flatten"><Icon name="download"/>CSV</Button>
                                //         </div>,
                                //         counter: '73',
                                //       },
                                //       subscribers: {
                                //         label:  'Subscribers',
                                // title:  'Subscribers',
                                //         component: <PAusersSubscribers history={hist} />,
                                //         extra: <div style={{display: 'flex',}}>
                                //           Export&nbsp;&nbsp;
                                //           <Button appearance="secondary" size="sm" appearance="flatten"><Icon name="download"/>XLS</Button>&nbsp;&nbsp;
                                //           <Button appearance="secondary" size="sm" appearance="flatten"><Icon name="download"/>CSV</Button>
                                //         </div>,
                                //         counter: '732',
                                //       }
                                //     }
                                //   },
                                //   extra: <div style={{display: 'flex',}}>
                                //     Export&nbsp;&nbsp;
                                //     <Button appearance="secondary" size="sm" appearance="flatten"><Icon name="download"/>XLS</Button>&nbsp;&nbsp;
                                //     <Button appearance="secondary" size="sm" appearance="flatten"><Icon name="download"/>CSV</Button>
                                //   </div>,
                                //   counter: '732',
                                // },
                              }}

                              // extra = {
                              //   <Select
                              //     align="right"
                              //     name=""
                              //     size="sm"
                              //     options={[
                              //       { label: "Project 1", value: 1 },
                              //       { label: "Project 2", value: 2 }
                              //     ]}
                              //     input={{
                              //       name: "widgTheme",
                              //       value: 1,
                              //       onChange: () => {
                              //         void 0;
                              //       }
                              //     }}
                              //   />
                            />
                          </div>
                        )}/>

                      {/* <Route exact path="/users/:keyId">
                    {(hist) => <div>
                      <PAusers hist={hist}/>
                    </div>}
                  </Route> */}
                      <Route path="/sb0/:keyId"
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="sb0"
                              title=""
                              appearance="full"
                              tabs={{
                                login: {
                                  appearance: "flatten",
                                  label: "",
                                  title: "",
                                  component: (
                                    <PAmodal
                                      size="xlg"
                                      handleModal={(
                                        backto = "/login/widget"
                                      ) => {
                                        hist.history.push(backto);
                                      }}
                                    >
                                      <PAsb0 product={"login"} />
                                    </PAmodal>
                                  ),
                                },
                                // login: {
                                //   // size: "full",
                                //   appearance: "flatten",
                                //   label: '',
                                //   title: '',
                                //   pop: {
                                //     size: 'xlg',
                                //     component: <PAmodal
                                //     size="xlg"
                                //     handleModal = {(backto = "/login/widget") => {
                                //     hist.history.push(backto);
                                //     }}>
                                //     <PAsb0 product={'login'}></PAsb0>
                                //   </PAmodal>,
                                //   },
                                //   component:<PAsb0 product={'game_store'} hist={hist}/>,
                                // },
                                bb: {
                                  size: "full",
                                  label: "",
                                  // title: 'Game stores',
                                  component: (
                                    <PAsb0
                                      product={"game_store"}
                                      // anchor={'store_widget1'}
                                      hist={hist}
                                    />
                                  ),
                                },
                                log: {
                                  size: "full",
                                  label: "",
                                  title: "",
                                  component: (
                                    <PAsb0
                                      product={"login"}
                                      // anchor={'login_mail'}
                                      hist={hist}
                                    />
                                  ),
                                },
                                sb: {
                                  size: "full",
                                  label: "",
                                  title: "",
                                  component: (
                                    <PAsb0
                                      product={"site_builder"}
                                      // anchor={'store_widget1'}
                                      hist={hist}
                                    />
                                  ),
                                },
                                ln: {
                                  size: "full",
                                  label: "",
                                  title: "",
                                  component: (
                                    <PAsb0
                                      product={"launcher"}
                                      // anchor={'login_mail'}
                                      hist={hist}
                                    />
                                  ),
                                },
                              }}
                            />
                          </div>
                        )}/>

                      <Route exact path="/solutions"
                        render={() => (<div>
                          {/* <PAmenu/> */}
                          <PAsolutionsMenu />
                        </div>)}
                      />
                      <Route path="/welcome">
                      render={()=> <div>
                          {/* <PAmenu/> */}
                          <PAwelcome />
                        </div>}
                      </Route>
                      {/* Login */}
                      <Route exact path={"/login"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="login"
                              title=""
                              appearance="flatten"
                              defaultPage={{
                                appearance: "flatten",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component: <PAblue product="login" seeMore />,
                              }}
                            />
                          </div>
                        )}/>

                      <Route exact path="/login/:keyId"
                        render={(history) => {
                          return (
                            <PApage
                              version={this.state.version}
                              root="login"
                              hist={history}
                              // border='md'
                              title="Login"
                              tabs={{
                                social: {
                                  label: "Social networks authentication",
                                  title: "Social networks authentication",
                                  component: <PAloginSocials />,
                                },
                                settings: {
                                  label: "Settings",
                                  title: "Settings",
                                  extra: <div
                                  className='login-container__header__id'
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    alignItems:'center'
                                  }}>PROJECT ID: 21313 <Button appearance='flatten'><Icon name='copy'/></Button>&nbsp;&nbsp;
                                  LOGIN ID: CE084F8D-89BF-11E8-Ad67-D89D67155224 <Button appearance='flatten'><Icon name='copy'/></Button>
                                  </div>,
                                  component: <PAloginSettings />,
                                },
                                widget: {
                                  label: "Widget & emails",
                                  title: "Widget & emails",
                                  component: <PAloginWidget />,
                                },
                              }}
                            />
                          );
                        }}/>

                      <Route exact path="/ps"
                        render={(hist) => {
                          return <PS0 history={hist} />;
                        }}/>

                      <Route exact path={"/paystation"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="paystation"
                              title=""
                              appearance="flatten"
                              defaultPage={{
                                appearance: "flatten",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component: (
                                  <PAblue product="pay_station" seeMore />
                                ),
                              }}
                            />
                          </div>
                        )}/>

                      <Route path="/paystation/:keyId"
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="paystation"
                              title="Pay Station"
                              tabs={{
                                settings: {
                                  label: "Settings",
                                  title: "Settings",
                                  component: <PApsSetting />,
                                },
                                methods: {
                                  label: "Payment methods",
                                  title: "Payment methods",
                                  component: <PApsPaymentMethods />,
                                },
                                payrank: {
                                  label: "Payrank",
                                  title: "",
                                  component: <PApsPayrank />,
                                  noTitle: true, //TODO: убирает заголовок страницы
                                },
                                gateways: {
                                  label: "Gateways", //это заголовок таба,
                                  title: null, //
                                  component: <PApsGateways />,
                                },
                              }}
                            />
                          </div>
                        )}/>

                      <Route path="/settings/:keyId"
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="settings"
                              title="Settings"
                              tabs={{
                                company: {
                                  label: "Company",
                                  title: "Company",
                                  component: <PAsettingsCompany />,
                                },
                                users: {
                                  label: "Users",
                                  title: "Users",
                                  component: <PAsettingsUsers />,
                                },
                                api: {
                                  label: "API key",
                                  title: "API key",
                                  component: <PAsettingsApi />,
                                },
                                contacts: {
                                  label: "Contacts",
                                  title: "Contacts", //
                                  component: <PAsettingsContactsFull />,
                                },
                                contacts_all_states: {
                                  label: "",
                                  title: "Contacts", //
                                  component: <PAsettingsContacts />,
                                },
                                contacts_empty: {
                                  label: "",
                                  title: "Contacts", //
                                  component: <PAsettingsContactsEmpty />,
                                },
                              }}
                            />
                          </div>
                        )}/>

                      {/* SB */}
                      {/* <Route exact path="/site_builder/new">
                    <div>
                      <PAsbSites />
                      <PAsbStartPopup/>
                    </div>
                  </Route>

                  <Route path="/site_builder/:keyId">
                    <div>
                      <PAsbProject />
                    </div>
                  </Route> */}


                    <Route exact path={"/site_builder"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="site_builder"
                              title=""
                              appearance="flatten"
                              defaultPage={{
                                appearance: "flatten",
                                size: "full",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component:  <PAblue product="site_builder" />,
                              }}
                            />
                          </div>
                        )}/>



                      <Route exact path="/site_builder/:keyId"
                        render={(hist) => {
                          return (
                            // <PAsbSettings />
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="site_builder"
                              title="Site Builder"




                              tabs={{
                                start: {
                                  label: "Start",
                                  title: "",
                                  appearance: "flatten",
                                  component: <PAblue product="site_builder" />,
                                },
                                sites: {
                                  label: "Start",
                                  title: "",
                                  appearance: "flatten",
                                  component: <PAsbSites />,
                                },
                                settings: {
                                  label: "Settings",
                                  title: "",
                                  appearance: "flatten",
                                  component: <PAsbSettings />,
                                },
                                versions: {
                                  label: "Versions",
                                  title: "Versions",
                                  // appearance: 'flatten',
                                  component: <PAsbVersions />,
                                },
                                newsite: {
                                  label: "",
                                  title: "",
                                  appearance: "flatten",
                                  size: "full",
                                  pop: {
                                    backUrl: "/site_builder",
                                    size: "md",
                                    appearance: "flatten",
                                    title: "New landing page",
                                    component: (
                                      <PAsbStartPopup history={hist} />
                                    ),
                                  },
                                  // appearance: 'flatten',
                                  component: <PAblue product="site_builder" />,
                                },
                              }}
                              // defaultPage = {{
                              //   appearance: "flatten",
                              //   noTitle: true, //TODO: убирает заголовок страницы
                              //   // customTrigger: true,
                              //   label:  'Start',
                              //   title:  'Start',
                              //   component: <PAblue product="site_builder"   />,
                              // }}
                            />
                          );
                        }}/>

                      <Route exact path={"/site_builder1/:keyId?"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="site_builder"
                              title=""
                              // appearance="flatten"
                              tabs={{
                                start: {
                                  appearance: "flatten",
                                  label: "",
                                  title: "",
                                  component: (
                                    <PAblue product="site_builder" seeMore />
                                  ),
                                },
                                newsite: {
                                  label: "",
                                  title: "",
                                  pop: {
                                    backUrl: "/site_builder",
                                    size: "md",
                                    title: "New landing page",
                                    component: (
                                      <PAsbStartPopup history={hist} />
                                    ),
                                  },
                                  appearance: "flatten",
                                  component: <PAblue product="site_builder" />,
                                },
                              }}
                              defaultPage={{
                                // appearance: "flatten",
                                // noTitle: true, //TODO: убирает заголовок страницы
                                // customTrigger: true,
                                label: "",
                                title: "",
                                component: <PAsbProjectP />,
                              }}
                            />
                          </div>
                        )}/>

                      {/* Launcher */}
                      <Route exact path={"/launcher"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="launcher"
                              title=""
                              appearance="flatten"
                              defaultPage={{
                                appearance: "flatten",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component: (
                                  <PAblue product="launcher" seeMore />
                                ),
                              }}
                            />
                          </div>
                        )}/>

                      <Route exact path="/launcher/new"
                        render={()=><div>
                          {/* <PAmenu/> */}
                          <PAlauncherNew />
                          {/* <PAlauncher /> */}
                          <PAblue product="launcher" />
                        </div>}/>


                      <Route path="/launcher/:keyId"
                        render={(hist) => (
                          <div>
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="launcher"
                              title="Launcher"
                              tabs={{
                                gateways: {
                                  label: "Gateways", //это заголовок таба,
                                  title: "Gateways", //это заголовок таба, надо переименовать
                                  component: <PAlauncherProject />,
                                  noTitle: true, //TODO: убирает заголовок страницы
                                },
                              }}
                            />
                            {/* <PAlauncherProject /> */}
                            {/* <PAmenu/> */}
                          </div>
                        )}/>

                      {/* Game Keys */}
                      {/* <Route exact path="/game_keys">
                    {(history) => {
                      return (
                      <div>
                      <PAgkDashboard
                        history={history}
                      />
                    </div>
                    )}}
                  </Route> */}
                      {/* <Route exact path="/game_store/newsite">
                    {(history) => {
                        return (
                        <PAgkDashboard keys={this.state.store.gameKeys.keys} history={history} />
                      )}}
                  </Route> */}
                      {/* <Route exact path="/game_store/newwidget">
                    <div>
                      <PAgkDashboard keys={this.state.store.gameKeys.keys} />
                    </div>
                  </Route> */}
                      {/* <Route exact path="/game_store/:keyId">
                    <div>
                      <PAgameKeys />
                    </div>
                  </Route> */}
                      {/* <Route exact path="/game_store/newkey">
                    {(history) => {
                      return (
                      <div>
                        <PAgkDashboard keys={this.state.store.gameKeys.keys}  history={history}/>
                      </div>
                    )}}
                  </Route> */}
                      {/* <Route exact path="/game_store">
                    {(hist) => {
                      hist.history.push(`/game_store/start`);
                      return null;
                    }}
                  </Route> */}
                      <Route exact path={"/game_store"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="game_store"
                              title=""
                              appearance="flatten"
                              defaultPage={{
                                appearance: "flatten",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component: (
                                  <PAblue product="game_store" seeMore />
                                ),
                              }}
                            />
                          </div>
                        )}/>

                      <Route path="/game_store/:keyId?"
                        render={(history) => {
                          return (
                            <PApage
                              version={this.state.version}
                              hist={history}
                              root="game_store"
                              title="Game store"
                              defaultPage={{
                                appearance: "flatten",
                                components: [
                                  {
                                    appearance: "flatten",
                                    component: <PAgameKeys history={history} />,
                                  },
                                  {
                                    appearance: "primary",
                                    title: "Distribute via embeddable widget",
                                    component: <WidgetWizard />,
                                  },
                                ],
                              }}
                              tabs={{
                                start: {
                                  customTrigger: true,
                                  appearance: "flatten",
                                  label: "start",
                                  title: "",
                                  component: (
                                    <div>
                                      <PAblue product="game_store" seeMore />
                                    </div>
                                  ),
                                  counter: vi.length,
                                },
                                goods: {
                                  label: "Games and distributives",
                                  title: "Buttons",

                                  components: [
                                    {
                                      label: "Buttons",
                                      title: "Games and distributives",
                                      extra: <>
                                        <Link to=''><Button appearance='flatten'><Icon name='list-view'/></Button></Link> &nbsp;&nbsp;| &nbsp;&nbsp;<Link to=''><Button appearance='flatten'><Icon name='tile-view'/></Button></Link>
                                      </>,
                                      appearance: "primary",
                                      cta: (
                                        <Link to="/game_store/new">
                                          <Button appearance="flatten">
                                            <Icon
                                              name="circle-plus"
                                              size={24}
                                            />
                                          </Button>
                                        </Link>
                                      ),
                                      component: (
                                        <div>
                                          <PAgkDashboard history={history} />
                                        </div>
                                      ),
                                    },
                                    {
                                      appearance: "flatten",
                                      component: (
                                        <PAblue
                                          seeMore
                                          title={
                                            <PAh2
                                              style={{ color: "white" }}
                                              limit={4}
                                              title="Add more ways to place your Game stores"
                                            />
                                          }
                                          product="game_store"
                                        />
                                      ),
                                    },
                                  ],
                                },
                                new: {
                                  customTrigger: true,
                                  label: "Buttons",
                                  title: "Buttons",
                                  pop: {
                                    backUrl: "/game_store/goods",
                                    size: "lg",
                                    title: "New product",
                                    component: (
                                      <PAgameKeysWizard
                                        history={history}
                                        create={true}
                                        WidgetWizard
                                        wizard={1}
                                      />
                                    ),
                                  },

                                  component: (
                                    <div>
                                      <PAgkDashboard history={history} />
                                    </div>
                                  ),
                                  cta: (
                                    <Link to="/game_store/new">
                                      <Button appearance="flatten">
                                        <Icon name="circle-plus" size={24} />
                                      </Button>
                                    </Link>
                                  ),
                                },

                                new_temp: {
                                  customTrigger: true,
                                  label: "Buttons",
                                  title: "Buttons",
                                  pop: {
                                    backUrl: "/game_store/goods",
                                    size: "lg",
                                    title: "New product",
                                    component: (
                                      <GameKeyWizard_temp
                                        history={history}
                                        create={true}
                                        WidgetWizard
                                        wizard={1}
                                      />
                                    ),
                                  },

                                  component: (
                                    <div>
                                      <PAgkDashboard history={history} />
                                    </div>
                                  ),
                                  cta: (
                                    <Link to="/game_store/new">
                                      <Button appearance="flatten">
                                        <Icon name="circle-plus" size={24} />
                                      </Button>
                                    </Link>
                                  ),
                                },

                                promotions: {
                                  label: "Promotions",
                                  title: "Promotions",
                                  // icon: "profile",
                                  component: (
                                    <div>
                                      <PApromos products={vpromos} />
                                    </div>
                                  ),
                                  counter: vpromos.length,
                                  cta: (
                                    <Link to="/game_store/new">
                                      <Button appearance="flatten">
                                        <Icon name="circle-plus" size={24} />
                                        {/* &nbsp;New promotion */}
                                      </Button>
                                    </Link>
                                  ),
                                },

                                new_widget: {
                                  // customTrigger: () => (<Link to="/game_store/new"><Button>+ New button</Button></Link>),
                                  // customTrigger: <Link to="/game_store/new"><Button size="sm">+ New button</Button></Link>,
                                  customTrigger: true,
                                  label: "New widget",
                                  title: "Game stores",
                                  pop: {
                                    backUrl: "/game_store/goods",
                                    title: "Game store widget",
                                    component: (
                                      <WidgetWizard history={history} />
                                    ),
                                  },
                                  component: (
                                    <div>
                                      <PAgkDashboard history={history} />
                                    </div>
                                  ),
                                },
                                new_physical: {
                                  // customTrigger: () => (<Link to="/game_store/new"><Button>+ New button</Button></Link>),
                                  // customTrigger: <Link to="/game_store/new"><Button size="sm">+ New button</Button></Link>,
                                  customTrigger: true,
                                  label: "New widget",
                                  title: "New widget",
                                  component: (
                                    <div>
                                      <PAgkDashboard history={history} />
                                      <WidgetWizard history={history} />
                                    </div>
                                  ),
                                },
                                new_promo: {
                                  // customTrigger: () => (<Link to="/game_store/new"><Button>+ New button</Button></Link>),
                                  // customTrigger: <Link to="/game_store/new"><Button size="sm">+ New button</Button></Link>,
                                  customTrigger: true,
                                  label: "New promotion",
                                  title: "New promotion",
                                  component: (
                                    <div>
                                      <PAgkDashboard history={history} />
                                      <GameKeyWizard_temp
                                        history={history}
                                        create={true}
                                        wizard={1}
                                      />
                                    </div>
                                  ),
                                },
                              }}
                              // extra = {<Link to="/game_store/new"><Button appearance="flatten" size="sm">+ New button</Button></Link>}
                            />
                          );
                        }}/>

                      {/*

                  <Route exact path="/subscriptions">
                    {(hist) => {
                      hist.history.push(`/subscriptions/plans`);
                      return null;
                    }}
                  </Route> */}
                      <Route exact path={"/subscriptions"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="subscriptions"
                              title=""
                              appearance="flatten"
                              defaultPage={{
                                appearance: "flatten",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component: (
                                  <PAblue product="subscriptions" seeMore />
                                ),
                              }}
                            />
                          </div>
                        )}/>

                      <Route exact path="/subscriptions/:keyId?"
                        render={(history) => {
                          return (
                            <PApage
                              version={this.state.version}
                              hist={history}
                              root="subscriptions"
                              title="Subscriptions"
                              tabs={{

                                analytics: {
                                  label:  'Analytics',
                                  title:  '',
                                  // appearance: 'flatten',
                                  component: <PAcharts
                                    flatten={true}
                                    hist={history}
                                    page='subscriptions'
                                    title='Users'
                                  />,
                                  // component: <PAsubsCharts hist={history} charts = {[
                                  //   'time',
                                  //   'plans',
                                  //   // 'plans2',
                                  //   'country'
                                  // ]}/>,
                                  // icon: "profile",
                                },
                                plans: {
                                  label: "Plans",
                                  title: "Plans",
                                  // icon: "profile",
                                  counter: 3,
                                  cta: (
                                    <Link to="/subscriptions/new">
                                      <Button appearance="flatten">
                                        <Icon name="circle-plus" size={24} />
                                        {/* &nbsp;New subscription plan */}
                                      </Button>
                                    </Link>
                                  ),
                                  // component: <div><PAsubs hist={history} products={subs}/></div>,
                                  components: [
                                    {
                                      // label:  'Buttons',
                                      // title:  'Buttons',
                                      // appearance: 'primary',
                                      // cta: <Link to="/game_store/new">
                                      //   <Button appearance="flatten"><Icon name="circle-plus" size={24}/></Button>
                                      // </Link>,
                                      component: (
                                        <div>
                                          <PAsubs
                                            hist={history}
                                            products={subs}
                                          />
                                        </div>
                                      ),
                                    },
                                    {
                                      appearance: "flatten",
                                      component: (
                                        <PAblue
                                          seeMore
                                          title={
                                            <PAh2
                                              style={{ color: "white" }}
                                              limit={4}
                                              title="Add more ways to use recurring payments"
                                            />
                                          }
                                          product="subscriptions"
                                          seeMore
                                        />
                                      ),
                                    },
                                  ],
                                },
                                promotions: {
                                  label: "Promotions",
                                  title: "Promotions",
                                  // icon: "profile",
                                  components: [
                                    {
                                      label: "Promotions",
                                      title: "Promotions",
                                      component: (
                                        <div>
                                          <PApromos products={vpromos} />
                                        </div>
                                      ),
                                      cta: (
                                        <Link to="/microtransactions/new">
                                          <Button appearance="flatten">
                                            <Icon
                                              name="circle-plus"
                                              size={24}
                                            />
                                            {/* &nbsp;New global promotion */}
                                          </Button>
                                        </Link>
                                      ),
                                    },
                                  ],
                                  counter: vpromos.length,
                                  cta: (
                                    <Link to="/microtransactions/new_promo">
                                      <Button appearance="flatten">
                                        <Icon name="circle-plus" size={24} />
                                        {/* &nbsp;New promotion */}
                                      </Button>
                                    </Link>
                                  ),
                                },
                                notifications: {
                                  label: "User notifications",
                                  title: "User notifications",
                                  // icon: "profile",
                                  component: (
                                    <div>
                                      <PAuserNotifications />
                                    </div>
                                  ),
                                  // counter: 1,
                                  // cta: <Link to="/subscriptions/new_promo"><Button appearance="flatten"><Icon name="circle-plus" size={24}/>&nbsp;New promotion</Button></Link>,
                                },
                                // refund_policy: {
                                //   label:  'Refund policy',
                                title: "Refund policy",
                                //   component: <PAgkRefund history={history} />,
                                //   status: <StatusDot status="testing"/>
                                //   // icon: "profile",
                                // },
                                new: {
                                  // customTrigger: () => (<Link to="/game_store/new"><Button>+ New button</Button></Link>),
                                  // customTrigger: <Link to="/game_store/new"><Button size="sm">+ New button</Button></Link>,
                                  customTrigger: true,
                                  label: "Plans",
                                  title: "Plans",
                                  pop: {
                                    size: "md",
                                    label: "New subscription plan",
                                    title: "New subscription plan",
                                    component: (
                                      <PAsubsNew
                                        history={history}
                                        create={true}
                                        wizard={1}
                                      />
                                    ),
                                    backUrl: "/subscriptions/plans",
                                  },
                                  component: (
                                    <div>
                                      <PAsubs hist={history} products={subs} />
                                    </div>
                                  ),
                                },

                                new_promo: {
                                  // customTrigger: () => (<Link to="/game_store/new"><Button>+ New button</Button></Link>),
                                  // customTrigger: <Link to="/game_store/new"><Button size="sm">+ New button</Button></Link>,
                                  customTrigger: true,
                                  label: "New promotion",
                                  title: "New promotion",
                                  component: (
                                    <div>
                                      <PAsubs hist={history} products={subs} />
                                      <GameKeyWizard_temp
                                        history={history}
                                        create={true}
                                        wizard={1}
                                      />
                                    </div>
                                  ),
                                },
                              }}
                            />
                          );
                        }}/>

                      {/*
                  <Route exact path="/microtransactions/:keyId?">
                    {(hist) => <div>
                      <PApage
                        version={this.state.version}
                        hist={hist}
                        root = 'microtransactions'
                        title = 'Microtransactions'
                        appearance="flatten"

                        tabs = {{
                          // start: {
                          //   customTrigger: true,
                          //   appearance: 'flatten',
                          //   label:  'start',
                          //   title:  '',
                          //   component: <div><PAblue product="microtransactions" /></div>,
                          //   counter: vi.length,
                          // },
                          integrate: {
                            customTrigger: true,
                            appearance: 'flatten',
                            pop: {
                              size: 'lg',
                              label:  'New virtual currency',
                              title:  'New virtual currency',
                              component: <PAvcNew hist={hist}/>,
                              backUrl: '/microtransactions',
                            },
                            label:  'Virtual items',
                            title:  'Virtual items',
                            component: <div><PAblue product="microtransactions" /></div>,
                            counter: vi.length,
                          },
                        }}

                      />
                    </div>}
                  </Route> */}
                      <Route exact path={"/microtransactions"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="microtransactions"
                              title=""
                              appearance="flatten"
                              defaultPage={{
                                appearance: "flatten",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "",
                                title: "",
                                component: (
                                  <PAblue product="microtransactions" seeMore />
                                ),
                              }}
                            />
                          </div>
                        )}/>

                      <Route exact path="/microtransactions/:keyId?"
                        render={(history) => {
                          return (
                            <PApage
                              version={this.state.version}
                              hist={history}
                              root="microtransactions"
                              title="Microtransactions"
                              tabs={{
                                virtual_items: {
                                  label: "Virtual items",
                                  title: "",
                                  appearance: "flatten",
                                  component: (
                                    <PAvirtualItems
                                      hist={history}
                                      products={vi}
                                    />
                                  ),
                                  counter: vi.length,
                                },

                                new_group: {
                                  customTrigger: true,
                                  appearance: "flatten",
                                  pop: {
                                    label: "New Group",
                                    title: "New Group",
                                    component: <PAviNewGroup hist={history} />,
                                    backUrl: "/microtransactions/virtual_items",
                                  },
                                  label: "Virtual items",
                                  title: "",
                                  component: (
                                    <PAvirtualItems
                                      hist={history}
                                      products={vi}
                                    />
                                  ),
                                  counter: vi.length,
                                },

                                new_item: {
                                  customTrigger: true,
                                  appearance: "flatten",
                                  pop: {
                                    label: "New Virtual Item",
                                    title: "New Virtual Item",
                                    component: (
                                      <PAviNewVirualItem hist={history} />
                                    ),
                                    backUrl: "/microtransactions/virtual_items",
                                  },
                                  label: "Virtual items",
                                  title: "",
                                  component: (
                                    <PAvirtualItems
                                      hist={history}
                                      products={vi}
                                    />
                                  ),
                                  counter: vi.length,
                                },

                                virtual_currency: {
                                  label: "Virtual currency",
                                  title: "Virtual currency packages",
                                  cta: (
                                    <Link to="/microtransactions/new_currency">
                                      <Button appearance="flatten">
                                        <Icon name="circle-plus" size={24} />
                                      </Button>
                                    </Link>
                                  ),
                                  // appearance: 'flatten',
                                  // component: <div><PAvirtualCurrency packs={vcpacks} hist={history} products={vc} /></div>,
                                  components: [
                                    // {
                                    //   appearance: "flatten",
                                    //   label: 'all',
                                    //   component: <FormGroup indentation="lg">
                                    //     <PAvirtualCurrency packs={null} hist={history} products={vc} />
                                    //   </FormGroup>,
                                    // },
                                    {
                                      // appearance: "flatten",
                                      title: "Virtual currency",
                                      label: "all",
                                      component: (
                                        <FormGroup indentation="lg">
                                          <PAvirtualCurrency
                                            history={history}
                                            products={vc}
                                          />
                                        </FormGroup>
                                      ),
                                    },
                                  ],
                                  counter: vc.length,
                                },

                                virtual_currency_old: {
                                  // label:  'Virtual currency',
                                  title: "Virtual currency",
                                  cta: (
                                    <Link to="/microtransactions/new_currency">
                                      <Button appearance="flatten">
                                        <Icon name="circle-plus" size={24} />
                                      </Button>
                                    </Link>
                                  ),
                                  appearance: "flatten",
                                  component: (
                                    <div>
                                      <PAvcs hist={history} products={vc} />
                                    </div>
                                  ),
                                  counter: vc.length,
                                },

                                new_currency: {
                                  customTrigger: true,
                                  // appearance: 'flatten',

                                  label: "Virtual currency",
                                  title: "Virtual currency",
                                  cta: (
                                    <Link to="/microtransactions/new_currency">
                                      <Button appearance="flatten">
                                        <Icon name="circle-plus" size={24} />
                                      </Button>
                                    </Link>
                                  ),
                                  pop: {
                                    // size: "lg",
                                    label: "Virtual currency settings",
                                    title: "Virtual currency settings",
                                    component: <PAvcNew hist={history} />,
                                    backUrl:
                                      "/microtransactions/virtual_currency",
                                  },
                                  component: (
                                    <PAvirtualCurrency
                                      history={history}
                                      products={vc}
                                    />
                                  ),
                                  counter: vi.length,
                                },

                                promotions: {
                                  label: "Promotions",
                                  title: "Promotions",
                                  // icon: "profile",
                                  components: [
                                    {
                                      label: "Global promotions",
                                      title: "Global promotions",
                                      component: (
                                        <div>
                                          <PApromos products={vpromos} />
                                        </div>
                                      ),
                                      cta: (
                                        <Link to="/microtransactions/new">
                                          <Button appearance="flatten">
                                            <Icon
                                              name="circle-plus"
                                              size={24}
                                            />
                                            {/* &nbsp;New global promotion */}
                                          </Button>
                                        </Link>
                                      ),
                                    },
                                    {
                                      label:
                                        "Virtual items specific promotions",
                                      title:
                                        "Virtual items specific promotions",
                                      component: (
                                        <div>
                                          <PApromos products={vpromos} />
                                        </div>
                                      ),
                                      // noTab: true,
                                      cta: (
                                        <Link to="/microtransactions/new">
                                          <Button appearance="flatten">
                                            <Icon
                                              name="circle-plus"
                                              size={24}
                                            />
                                            {/* &nbsp;New subscription promotion */}
                                          </Button>
                                        </Link>
                                      ),
                                    },
                                    {
                                      label:
                                        "Virtual currency specific promotions",
                                      title:
                                        "Virtual currency specific promotions",
                                      component: (
                                        <div>
                                          <PApromos products={vpromos} />
                                        </div>
                                      ),
                                      // noTab: true,
                                      cta: (
                                        <Link to="/microtransactions/new">
                                          <Button appearance="flatten">
                                            <Icon
                                              name="circle-plus"
                                              size={24}
                                            />
                                            {/* &nbsp;New subscription promotion */}
                                          </Button>
                                        </Link>
                                      ),
                                    },
                                  ],
                                  counter: vpromos.length,
                                  cta: (
                                    <Link to="/microtransactions/new_promo">
                                      <Button appearance="flatten">
                                        <Icon name="circle-plus" size={24} />
                                        {/* &nbsp;New promotion */}
                                      </Button>
                                    </Link>
                                  ),
                                },

                                // refund_policy: {
                                //   label:  'Refund policy',
                                title: "Refund policy",
                                //   component: <PAgkRefund history={history} />,
                                //   status: <StatusDot status="testing"/>
                                //   // icon: "profile",
                                // },

                                new: {
                                  // customTrigger: () => (<Link to="/game_store/new"><Button>+ New button</Button></Link>),
                                  // customTrigger: <Link to="/game_store/new"><Button size="sm">+ New button</Button></Link>,
                                  customTrigger: true,
                                  label: "New subscription plan",
                                  title: "New subscription plan",
                                  component: (
                                    <div>
                                      <PAviGroup hist={history} products={vi} />
                                      <GameKeyWizard_temp
                                        history={history}
                                        create={true}
                                        wizard={1}
                                      />
                                    </div>
                                  ),
                                },

                                new_promo: {
                                  // customTrigger: () => (<Link to="/game_store/new"><Button>+ New button</Button></Link>),
                                  // customTrigger: <Link to="/game_store/new"><Button size="sm">+ New button</Button></Link>,
                                  customTrigger: true,
                                  label: "New promotion",
                                  title: "New promotion",
                                  component: (
                                    <div>
                                      <PApromos products={vpromos} />
                                      <GameKeyWizard_temp
                                        history={history}
                                        create={true}
                                        wizard={1}
                                      />
                                    </div>
                                  ),
                                },
                              }}
                            />
                          );
                        }}/>

                      <Route exact path="/documents"
                        render={(hist) => {
                          hist.history.push(`/documents/refunds`);
                          return null;
                        }}/>

                      <Route exact path="/documents/:keyId?"
                        render={(history) => {
                          return (
                            <PApage
                              version={this.state.version}
                              hist={history}
                              root="documents"
                              title="Documents"
                              tabs={{
                                agreements: {
                                  label: "Licensing agreement",
                                  title: "Licensing agreement",
                                  component: <PAaccountingDocuments />,
                                  // status: <StatusDot status="testing"/>
                                  // icon: "profile",
                                },
                                refunds4: {
                                  customTrigger: true,
                                  label: "Fast&fair Refunds",
                                  // appearance: 'flatten',
                                  title: "Fast&fair Refunds",
                                  component: (
                                    <div>
                                      <PAgkRefund
                                        history={history}
                                        products={[
                                          {
                                            product: "game_store",
                                            level: "strict",
                                          },
                                        ]}
                                      />
                                    </div>
                                  ),
                                  status: <StatusDot status="testing" />,
                                  // icon: "profile",
                                },
                                refunds2: {
                                  customTrigger: true,
                                  label: "Fast&fair Refunds",
                                  // appearance: 'flatten',
                                  title: "Fast&fair Refunds",
                                  component: (
                                    <PAgkRefund
                                      history={history}
                                      products={[
                                        {
                                          product: "game_store",
                                          level: "moderate",
                                        },
                                        {
                                          product: "subscriptions",
                                          level: "moderate",
                                        },
                                      ]}
                                    />
                                  ),
                                  status: <StatusDot status="testing" />,
                                  // icon: "profile",
                                },
                                simple_checkout: {
                                  customTrigger: true,
                                  label: "Fast&fair Refunds",
                                  // appearance: 'flatten',
                                  title: "Fast&fair Refunds",
                                  component: (
                                    <PAgkRefund
                                      history={history}
                                      products={
                                        [
                                          // {
                                          // product: 'simple_checkout',
                                          // level: 'loyal',
                                          // }
                                        ]
                                      }
                                    />
                                  ),
                                  status: <StatusDot status="testing" />,
                                  // icon: "profile",
                                },
                                // refunds3: {
                                //   customTrigger: true,
                                //   label:  'Fast&fair Refunds',
                                //   // appearance: 'flatten',
                                //   title:  'Fast&fair Refunds',
                                //   component: <div><PAgkRefund history={history} /></div>,
                                //   status: <StatusDot status="testing"/>
                                //   // icon: "profile",
                                // },
                                refunds: {
                                  label: "Fast&fair Refunds",
                                  // appearance: 'flatten',
                                  title: "Fast&fair Refunds",
                                  component: (
                                    <div>
                                      <PAgkRefundSimple history={history} />
                                    </div>
                                  ),
                                  status: <StatusDot status="testing" />,
                                  // icon: "profile",
                                },
                                refundnew: {
                                  customTrigger: true,
                                  label: "Fast&fair Refunds",
                                  // appearance: 'flatten',
                                  title: "Fast&fair Refunds",
                                  component: (
                                    <div>
                                      <PAgkRefundSimple
                                        newPartner={true}
                                        history={history}
                                      />
                                    </div>
                                  ),
                                  status: <StatusDot status="testing" />,
                                  // icon: "profile",
                                },
                                refunds_preview: {
                                  customTrigger: true,
                                  label: "Fast&fair Refunds",
                                  // appearance: 'flatten',
                                  title: "Fast&fair Refunds",
                                  pop: {
                                    size: "lg",
                                    title: "Refund policy configuration",
                                    component: <PArefundPreview />,
                                    extra: <PArefundVersion />,
                                    backUrl: "/documents/refunds",
                                  },
                                  component: (
                                    <div>
                                      <PAgkRefund history={history} />
                                    </div>
                                  ),
                                  status: <StatusDot status="testing" />,
                                  // icon: "profile",
                                },
                                refunds_edit: {
                                  customTrigger: true,
                                  label: "Fast&fair Refunds",
                                  // appearance: 'flatten',
                                  // title: 'Fast&fair Refunds',
                                  pop: {
                                    size: "lg",
                                    title: "Edit refund policy",
                                    component: (
                                      <PAgkRefundEdit history={history} />
                                    ),
                                    backUrl: "/documents/refunds",
                                  },
                                  component: <PAgkRefund history={history} />,
                                  status: <StatusDot status="testing" />,
                                  // icon: "profile",
                                },

                                refund_old: {
                                  customTrigger: true,
                                  label: "Refund policy configurator",
                                  title: "Refund policy configurator",
                                  component: (
                                    <div>
                                      <PAgkRefund_old history={history} />
                                    </div>
                                  ),
                                  status: <StatusDot status="testing" />,
                                  // icon: "profile",
                                },
                              }}
                            />
                          );
                        }}/>

                      <Route exact path="/transactions/:keyId?"
                        render={(history) => {
                          return (
                            <PApage
                              version={this.state.version}
                              hist={history}
                              root="transactions"
                              title="Transactions"
                              tabs={{
                                registry: {
                                  size: "wide",
                                  label: "Transaction registry",
                                  title: "Transaction registry",
                                  component: <PAaccountingTransactions />,
                                  // icon: "profile",
                                  // counter: vi.length,
                                  // cta: <Link to="/microtransactions/new"><Button appearance="flatten"><Icon name="circle-plus" size={24}/>&nbsp;New virtual item</Button></Link>,
                                },
                                payouts: {
                                  size: "wide",
                                  label: "Payouts",
                                  // title:  'Payouts',
                                  component: <PAaccountingPayouts />,
                                  // extra: <div><div className="custom-dropdown custom-dropdown--position-null"><div style={{display: 'block'}}><div style={{position: 'relative', width: '100%', display: 'block'}}><button name="year-picker" value="2019, All months" className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-left xsui-input--read-only" type="button" data-id="year-picker" data-value="2019, All months">2019, All months</button><div className="xsui-input__icon"><i className="xsui-icon xsui-icon-calendar" style={{fontSize: 24, color: 'inherit'}} /></div></div><div /></div><div /></div></div>

                                  // counter: vc.length,
                                  // cta: <Link to="/microtransactions/new_vc"><Button appearance="flatten"><Icon name="circle-plus" size={24}/>&nbsp;New virtual currency</Button></Link>,
                                },
                                reports: {
                                  size: "wide",
                                  label: "Reports",
                                  title: "Reports",
                                  // icon: "profile",
                                  component: <PAaccountingReports />,
                                  counter: vpromos.length,
                                  // cta: <Link to="/microtransactions/new_promo"><Button appearance="flatten"><Icon name="circle-plus" size={24}/>&nbsp;New promotion</Button></Link>,
                                },
                              }}
                            />
                          );
                        }}/>

                      <Route exact path="/stats/:keyId?"
                        render={(history) => {
                          return (
                            <PApage
                              version={this.state.version}
                              hist={history}
                              root="stats"
                              title="Analytics"
                              //   defaultPage = {{
                              //     size: 'wide',
                              //     // appearance: "flatten",
                              //     noTitle: true, //TODO: убирает заголовок страницы
                              //     customTrigger: true,
                              //     label:  '',
                              //     title:  '',
                              //     component: <PAcharts />,
                              // }}

                              tabs={{
                                // default: {
                                //   // size: 'wide',
                                //   label: "Payments",
                                //   title: "Payments",
                                //   component: (
                                //     <div>
                                //       <PAdashPayouts />
                                //       <PAsubsCharts
                                //         charts={[
                                //           // "time",
                                //           // "plans",
                                //           "country",
                                //         ]}
                                //         // empty={true}
                                //         // charts={[
                                //         //  ...chartSubs
                                //         // ]}
                                //       />
                                //     </div>
                                //   ),
                                //   // icon: "profile",
                                //   // counter: vi.length,
                                //   // cta: <Link to="/microtransactions/new"><Button appearance="flatten"><Icon name="circle-plus" size={24}/>&nbsp;New virtual item</Button></Link>,
                                // },
                                all: {
                                  // size: 'wide',
                                  label: "Custom dashboard",
                                  // title: "Payments",
                                  appearance: "flatten",
                                  component: <PAcharts
                                    flatten={true}
                                    />,
                                },
                                payments: {
                                  // size: 'wide',
                                  label: "Payments",
                                  // title: "Payments",
                                  // appearance: "flatten",
                                  component: <div className="">
                                    <div style={{
                                      width: '100%',
                                      height: 2011,
                                      background: 'no-repeat 50% 0 url(https://res.cloudinary.com/maiik/image/upload/v1594918782/Xsolla_PA/stats_fake.png)'
                                    }}/>
                                  </div>,
                                },
                                antifraud: {
                                  // size: 'wide',
                                  label: "Antifraud",
                                  // title: "Payments",
                                  // appearance: "flatten",
                                  component: <PAantifraud />,
                                },
                                users: {
                                  // size: 'wide',
                                  label: "Users",
                                  // title`: "Payments",
                                  // appearance: "flatten",
                                  component: <PAloginStats  charts={[
                                    "time",
                                    'methods',
                                    "country",
                                  ]} />,
                                },
                                ceo: {
                                  // size: 'wide',
                                  label: "CEO dashboard",
                                  // title: "Payments",
                                  // appearance: "flatten",
                                  component: <div>
                                    <ContentBlock>
                                      Connect third party platforms to see aggregated statistics
                                    </ContentBlock>
                                    <PAdashConnectors/>
                                  </div>,
                                },

                              }}
                            />
                          );
                        }}/>

                      <Route exact path="/antifraud"
                        render={(hist) => {
                          hist.history.push(`/antifraud/main`);
                          return null;
                        }}/>

                      <Route exact path="/antifraud/:keyId"
                        render={(history) => {
                          return (
                            <PApage
                              version={this.state.version}
                              hist={history}
                              root="antifraud"
                              title="Antifraud"
                              tabs={{
                                main: {
                                  label: "Analytics",
                                  title: "",
                                  component: <PAantifraud />,
                                  appearance: "flatten",
                                },
                                users: {
                                  label: "Fraudlent users",
                                  title: "Fraudlent users",
                                  component: <PAantifraudUsers />,
                                  status: <StatusDot status="error" />,
                                  // appearance: 'flatten',
                                },
                                components: {
                                  label: "Antifraud components",
                                  title: "",
                                  component: <PAantifraudComponents />,
                                  appearance: "flatten",
                                  counter: "3",
                                },
                              }}
                            />
                          );
                        }}/>

                      <Route exact path="/uikit2/sku"
                        render={(hist) => {
                          return (
                            <PAmodal
                              size="md"
                              handleModal={(backto = "/uikit2/sku") => {
                                hist.history.push(backto);
                              }}
                            >
                              <TempSkuName />
                            </PAmodal>
                          );
                        }}/>

                      {/* <Route exact path="/microtransactions/vi/:grouId">
                    {(hist) => <div>
                      <PAviGroup  hist={hist}/>
                    </div>}
                  </Route> */}
                      {/* <Route  path="/microtransactions/vi/:grouId/:keyId">
                    {(hist) => <div>
                      <PAviItem  hist={hist}/>
                    </div>}
                  </Route> */}
                      {/* TEMP */}
                      <Route exact path="/charts"
                        render={()=><div>
                          <PAcharts />
                        </div>}/>

                      <Route exact path="/chartmap"
                        render={()=><div>
                          <PAchartMap />
                        </div>}
                      />
                      <Route exact path="/allconnectors"
                        render={()=><div>
                          <PAallConnectors />
                        </div>}/>


                      <Route exact path={"/partner_network"}
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}
                            <PApage
                              version={this.state.version}
                              hist={hist}
                              root="partner_network"
                              title=""
                              appearance="flatten"
                              defaultPage={{
                                appearance: "flatten",
                                noTitle: true, //TODO: убирает заголовок страницы
                                customTrigger: true,
                                label: "Start",
                                // title:  'Start',
                                component: (
                                  <PAblue product="partner_network" seeMore />
                                ),
                              }}
                            />
                          </div>
                        )}/>

                      <Route exact path="/partner_network/:keyId"
                        render={(history) => {
                          return (
                            <PApage
                              version={this.state.version}
                              hist={history}
                              root="partner_network"
                              title="Partner Network"
                              tabs={{
                                main: {
                                  label: "Partner Network",
                                  title: "Partner Network",
                                  component: <PApn />,
                                  // appearance: 'flatten',
                                  //                               customTrigger: true,
                                },
                              }}
                            />
                          );
                        }}/>

                      {/* <Route exact path="/dashboard/:keyId?">
                    {(hist) => {
                      hist.history.push(`/dashboard/main`);
                      return null;
                    }}
                </Route> */}
                      <Route path="/dashboard/:keyId?"
                        render={(hist) => (
                          <div>
                            {/* <PAmenu/> */}

                            {this.state.version === "poydo" && (
                              <PApage
                                dashboard={true}
                                version={this.state.version}
                                hist={hist}
                                {...dashFull}
                              />
                            )}

                            {this.state.version === "misha" && (
                              <PApage
                                dashboard={true}
                                version={this.state.version}
                                hist={hist}
                                {...dashMisha}
                              />
                            )}
                          </div>
                        )}/>

                      {/* <Route>
                    {(hist) => {
                      hist.history.push(`/dashboard/main`);
                      return null;
                    }}
                </Route> */}
                    </Switch>
                  </div>

                  {/* </div> */}
                </GlobalContext.Provider>
              </div>
            </Router>
          </div>
          {/* </ContentBlock>
    </CssContentBlock> */}
        </CSSthemer>
      </IntlProvider>
      // </ThemeProvider>
    );
  }
}

export const CssContentBlock = styled.div`
  margin-bottom: 64px;
  ${({ width }) =>
    width &&
    css`
      & .xsui-content-block {
        max-width: none;
      }
    `}
`;
